module.exports = "/assets/data/d706a8a28de82a87ffbd8f2f3d9b7d3e-SW20.data.json";